import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../../api/pickupOrderRemote';

import GhaAwbLocationData from './GhaAwbLocationData';
import GhaAwbCustomClearanceStatus from './GhaAwbCustomClearanceStatus';
import GhaAwbPaymentStatus from './GhaAwbPaymentStatus';

import AwbParams from '../../../../models/AwbParams';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import GhaAwbLocationPcs from '../../../../models/GhaAwbLocationPcs';
import GhaPickupStatusAwb from '../../../../models/GhaPickupStatusAwb';

import { extractAwbCodeAndNumber } from '../../../../utils/airwayBill';
import { PO_AWB_SCHEMA } from '../../../../utils/pickupOrder';

import ghaPickupStatusStyles from './ghaPickupStatus.module.css';
import commonStyles from '../../../common/common.module.css';
import InfoToWsContainer from '../../../readyForCarriageCheck/infoToWh/InfoToWsContainer';
import GeneralRemarksContainer from '../../../common/generalRemarks/GeneralRemarksContainer';

interface GhaPickupStatusContainerProps {
  receiveError: Function;
  poNumber: string;
  awbCodeNumber: string;
  due: boolean;
  updateLocations: boolean;
  updateCustomsClearance: boolean;
  setWeight: (weight: string) => void;
  triggerAwbsUpdate: any;
};

interface GhaPickupStatusContainerState {
  statusLocationPcs: GhaPickupStatusAwb;
  tempLocationAndPcs: { pieces: number | string; location: string; };
  showNewLocationPcsRow: boolean;
  expandLocationData: boolean;
  expandCustomsClearance: boolean;
  expandPaymentConfirmed: boolean;
  customsClearanceChecked: { yes: boolean; no: boolean; };
  pcs_error: boolean;
};

class GhaPickupStatusContainer extends Component<GhaPickupStatusContainerProps, GhaPickupStatusContainerState> {

  state: GhaPickupStatusContainerState = {
    statusLocationPcs: PO_AWB_SCHEMA,
    tempLocationAndPcs: {
      pieces: '',
      location: ''
    },
    showNewLocationPcsRow: false,
    expandLocationData: false,
    expandCustomsClearance: false,
    expandPaymentConfirmed: false,
    pcs_error: false,
    customsClearanceChecked: {
      yes: false,
      no: true
    }
  }

  componentDidMount() {

    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbCodeNumber);

    pickupOrderRemote.getGhaPoAwbWhLocationAndPcs(this.props.poNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version).then(this.handleCommonResponse);
  }

  componentDidUpdate(prevProps: GhaPickupStatusContainerProps) {

    const poChanged = prevProps.poNumber !== this.props.poNumber;
    const awbChanged = prevProps.awbCodeNumber !== this.props.awbCodeNumber;

    if (poChanged || awbChanged) {
      
      this.setState({
        statusLocationPcs: { ...PO_AWB_SCHEMA },
        tempLocationAndPcs: { pieces: '', location: '' },
        showNewLocationPcsRow: false,
        expandLocationData: false,
        expandCustomsClearance: false,
        expandPaymentConfirmed: false,
        pcs_error: false,
        customsClearanceChecked: {
          yes: !!PO_AWB_SCHEMA.customs_cleared,
          no: !PO_AWB_SCHEMA.customs_cleared
        }
      });

      if (poChanged || awbChanged) {
        const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbCodeNumber);
      
        pickupOrderRemote.getGhaPoAwbWhLocationAndPcs(this.props.poNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version).then(this.handleCommonResponse);
      }
      
    }
  }

  handleExpandChange = (expandType: string, forceOpen?: boolean): void => {

    let newValue: boolean = false;

    switch (expandType) {

      case 'locationData':

        newValue = !this.state.expandLocationData;

        if (forceOpen) {
          newValue = forceOpen;
        }

        this.setState({ expandLocationData: newValue });
        break;
      case 'customsClearance':

          newValue = !this.state.expandCustomsClearance;

          this.setState({ expandCustomsClearance: newValue });
        break;
      default: break;
    }
  }

  handleInputValueChange = (event: React.ChangeEvent<HTMLInputElement>, inputType: string): void => {

    const inputValue: string = event.target.value;
    const tempLocationAndPcs: { pieces: number | string; location: string; } = { ...this.state.tempLocationAndPcs };

    switch (inputType) {

      case 'location': tempLocationAndPcs.location = inputValue; break;
      case 'pieces':

        const integerRegex: RegExp = new RegExp(/^\d+$/);
        const totalAllowedPcs: number = this.state.statusLocationPcs.pieces;
        const ghaAwbLocationPcs: Array<GhaAwbLocationPcs> = this.state.statusLocationPcs.wh_location.data;
        const length: number = ghaAwbLocationPcs.length;
        let totalInputPcs: number = 0;
        let val: number = 0;
        let hasError: boolean = false;

        for (let i = 0; i < length; i++) {
          totalInputPcs += ghaAwbLocationPcs[i].pieces;
        }

        if (integerRegex.test(inputValue)) {
          
          val = parseInt(inputValue);

          if (val + totalInputPcs > totalAllowedPcs) {
            hasError = true;
          } else {
            hasError = false;
          }

          this.setState({ pcs_error: hasError });
        }

        tempLocationAndPcs.pieces = val === 0 ? '' : val; break;
      default: break;
    }

    this.setState({ tempLocationAndPcs });
  }

  addNewLocationAndPcsRow = (): void => {

    const totalAllowedPcs: number = this.state.statusLocationPcs.pieces;
    const ghaAwbLocationPcs: Array<GhaAwbLocationPcs> = this.state.statusLocationPcs.wh_location.data;
    const length: number = ghaAwbLocationPcs.length;
    let totalInputPcs: number = 0;

    for (let i = 0; i < length; i++) {
      totalInputPcs += ghaAwbLocationPcs[i].pieces;
    }

    if (totalInputPcs < totalAllowedPcs) {
      this.setState({ showNewLocationPcsRow: true });
    }
  }
  

  doAddLocationAndPcs = (defaultOption: boolean): void => {
    
    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbCodeNumber);
    const lastRow: { pieces: number | string; location: string; } = { ...this.state.tempLocationAndPcs };
    const piecesStr: any = lastRow.pieces; // Forced to be any, because of number | string
    const lastRowOriginal: GhaAwbLocationPcs = { ...lastRow, pieces: parseInt(piecesStr) };
    if(defaultOption) {
      lastRowOriginal.defaultOption = true;
    }

    pickupOrderRemote.addGhaPoAwbWhLocationAndPcs(this.props.poNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version, lastRowOriginal).then((resp: ApiResponse<GhaPickupStatusAwb>) => {

      const statusLocationPcs: GhaPickupStatusAwb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
  
      if (statusLocationPcs) {
        this.setState({
          statusLocationPcs,
          showNewLocationPcsRow: false,
          tempLocationAndPcs: { pieces: '', location: '' }
        });
        this.props.setWeight(statusLocationPcs.weight);
        this.props.triggerAwbsUpdate();
      }
  
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  doRemoveLocationAndPcs = (element?: GhaAwbLocationPcs): void => {

    if (!element) {

      this.setState({
        pcs_error: false,
        showNewLocationPcsRow: false,
        tempLocationAndPcs: { pieces: '', location: '' }
      });

    } else {

      const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbCodeNumber);
      const pureElement: GhaAwbLocationPcs = { ...element, pieces: element.pieces, location: element.location };
  
      pickupOrderRemote.deleteGhaPoAwbWhLocationAndPcs(this.props.poNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version, pureElement).then(this.handleCommonResponse);
    }
  }

  handleCommonResponse = (resp: ApiResponse<GhaPickupStatusAwb>): void => {

    const statusLocationPcs: GhaPickupStatusAwb | undefined = resp.result;
    const error: ResponseError | undefined = resp.error;

    if (statusLocationPcs) {
      const customsClearanceChecked: {yes: boolean, no: boolean} = {
        yes: statusLocationPcs.customs_cleared,
        no: !statusLocationPcs.customs_cleared
      };

      this.setState({ statusLocationPcs,
        customsClearanceChecked: {... customsClearanceChecked},
      });

      this.props.triggerAwbsUpdate();
    }

    if (error) {
      this.props.receiveError(error);
    }
  }
  
  setStatePoAwb = (poAwb: GhaPickupStatusAwb): void => {
    this.setState({ statusLocationPcs: poAwb });
  }

  doUpdateCustomsClearanceStatus = (event: React.ChangeEvent<HTMLInputElement>): void => {

    const awbParams: AwbParams = extractAwbCodeAndNumber(this.props.awbCodeNumber);
    const status: boolean = event.target.value === 'yes';

    pickupOrderRemote.updateGhaPoAwbWhCustomsClearanceStatus(this.props.poNumber, awbParams.awbCode, awbParams.awbNumber, awbParams.version, { customs_clearance: status }).then((resp: ApiResponse<boolean>) => {
      this.handleStatusResponse(status, resp);
    });
  }

  handleStatusResponse = (status: boolean, resp: ApiResponse<boolean>): void => {

    const success: boolean | undefined = resp.success;
    const error: ResponseError | undefined = resp.error;

    if (success) {
      const checked: {yes: boolean, no: boolean} = {
        yes: status,
        no: !status
      };

      this.setState({ customsClearanceChecked: checked});
      this.props.triggerAwbsUpdate();
    }

    if (error) {
      this.props.receiveError(error);
    }
  }

  render () {

    return (

      <div className={ `${ commonStyles.wrapper } ${ ghaPickupStatusStyles.statusWrapper } ${ commonStyles.h100 }` } >

        <h3 className={ `${ commonStyles.header }` }>Pick Up Status</h3>
        <div>
           <GhaAwbLocationData
            locationsAndPcs={ this.state.statusLocationPcs }
            handleExpandChange={ this.handleExpandChange }
            expandLocationData={ this.state.expandLocationData }
            showNewLocationPcsRow={ this.state.showNewLocationPcsRow }
            tempLocationAndPcs={ this.state.tempLocationAndPcs }
            handleInputValueChange={ this.handleInputValueChange }
            addNewLocationAndPcsRow={ this.addNewLocationAndPcsRow }
            doAddLocationAndPcs={ this.doAddLocationAndPcs }
            doRemoveLocationAndPcs={ this.doRemoveLocationAndPcs }
            pcs_error={ this.state.pcs_error }
            updateLocations={ this.props.updateLocations }
          />
        </div>

        <div>
          <GhaAwbCustomClearanceStatus
            handleExpandChange={ this.handleExpandChange }
            expandComponent={ this.state.expandCustomsClearance }
            componentChecked={ this.state.customsClearanceChecked }
            updateStatus={ this.doUpdateCustomsClearanceStatus }
            updateCustomsClearance={ this.props.updateCustomsClearance }
          />
        </div>

        <div className={ ghaPickupStatusStyles.wrapperPayed }>
          < GhaAwbPaymentStatus due={ this.props.due } />
        </div>
        <div className={ ghaPickupStatusStyles.wrapperInfoToWs }>
          <InfoToWsContainer
            poAwb={ this.state.statusLocationPcs }
            doNumber={ this.props.poNumber }
            code={ this.props.awbCodeNumber.split('-')[0] }
            number={ this.props.awbCodeNumber.split('-')[1] }
            ver={ Number(this.props.awbCodeNumber.split('-')[2]) }
            setStatePoAwb={ this.setStatePoAwb }
            onlyRead={ false }
          />
        </div>
        <div className={ ghaPickupStatusStyles.wrapperInfoToWs }>
          <GeneralRemarksContainer
            poAwb={ this.state.statusLocationPcs }
            doNumber={ this.props.poNumber }
            code={ this.props.awbCodeNumber.split('-')[0] }
            number={ this.props.awbCodeNumber.split('-')[1] }
            setStatePoAwb={ this.setStatePoAwb }
            onlyRead={ false }
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(GhaPickupStatusContainer);